import { deepFreeze } from 'utils/deepFreeze';
import type { ShopByListState } from '../types';

export const initialState: Readonly<ShopByListState> = deepFreeze({
  eligibility: {},
  processing: {},
  viewAllModalProducts: {
    currentItemId: undefined,
    currentSearchTerm: undefined,
    hasError: false,
    isLoading: true,
    products: [],
    requestId: undefined,
  },
});
